import "core-js/modules/es.string.trim.js";
export var validateActionDescription = function validateActionDescription(props) {
  var validText = props.text.trim();

  if (validText) {
    return props.onValid();
  }

  props.onError();
};